export enum TravelCompanion {
  SOLO = 'Solo',
  GROUP = 'With Others',
  // FAMILY_NO_MINOR = 'Family without Minors',
  // FAMILY = 'Family with Minor Children'
}
